import { call, put, takeLatest } from "redux-saga/effects";
import * as types from "../actions/actionTypes";
import {
  AccountTitleAction,
  ContactAction,
  CostCenterAction,
  HashtagAction,
  InitAction,
  SubItemsSharedAction,
  TeamAction
} from "../actions";
import * as teamApi from "../api/team";
import { toastr } from "react-redux-toastr";
import { SetMessage } from "../assets/errorMessages";
import { goBack } from "connected-react-router";
import { TEAM_SUB_ITEM } from "../constants/teamManagement";
import {
  getTeamsArrayAfterAddTeam, getTeamsArrayAfterEditTeam,
  getTeamsArrayAfterRemoveTeam
} from "../assets/currentProjectTeamsChange";

export function* watcherProjectTeam() {
  yield takeLatest(types.GET_TEAMS_LIST_REQUEST, list);
  yield takeLatest(types.SHOW_TEAM_REQUEST, show);
  yield takeLatest(types.REMOVE_TEAM_REQUEST, remove);
  yield takeLatest(types.STORE_TEAM_REQUEST, store);
  yield takeLatest(types.UPDATE_TEAM_REQUEST, update);
  yield takeLatest(types.GET_TEAM_LEVELS_REQUEST, getLevels);
  yield takeLatest(types.REORDER_TEAM_LEVELS_REQUEST, reorderLevels);
  yield takeLatest(types.SHOW_TEAM_LEVEL_REQUEST, showLevel);
  yield takeLatest(types.REMOVE_TEAM_LEVEL_REQUEST, removeLevel);
  yield takeLatest(types.STORE_TEAM_LEVEL_REQUEST, storeLevel);
  yield takeLatest(types.UPDATE_TEAM_LEVEL_REQUEST, updateLevel);
  yield takeLatest(
    types.REMOVE_TEAM_LEVEL_APPROVER_REQUEST,
    removeLevelApprover
  );
  yield takeLatest(types.GET_TEAM_LEVEL_APPROVERS_REQUEST, getLevelApprovers);
  yield takeLatest(types.STORE_TEAM_LEVEL_APPROVER_REQUEST, storeLevelApprover);
  yield takeLatest(types.UPDATE_TEAM_WIDGETS_REQUEST, updateWidgets);
}

function getListRequest(data) {
  return teamApi.list(data);
}

function* list(action) {
  try {
    const response = yield call(getListRequest, action.data);
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(TeamAction.getListSuccess(response.data.data));
  } catch (error) {
    const message = SetMessage(error);
    // dispatch a failure action to the store with the error
    yield put(TeamAction.getListFailure(message));
  }
}

function showRequest(id) {
  return teamApi.show(id);
}

function* show(action) {
  try {
    const response = yield call(showRequest, action.id);
    yield put(TeamAction.showSuccess(response.data.data));
  } catch (error) {
    const message = SetMessage(error);
    yield put(TeamAction.showFailure(message));
  }
}

function removeRequest(id) {
  return teamApi.remove(id);
}

function* remove(action) {
  try {
    const response = yield call(removeRequest, action.id);
    yield put(
      InitAction.getSuccess({
        projectData: { teams: getTeamsArrayAfterRemoveTeam(action.id) }
      })
    );
    yield put(TeamAction.removeSuccess(action.id));
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(goBack());
  } catch (error) {
    SetMessage(error, true);
    yield put(TeamAction.removeFailure());
  }
}

function storeRequest(projectId, data) {
  return teamApi.store(projectId, data);
}

function* store(action) {
  try {
    const response = yield call(storeRequest, action.projectId, action.data);
    yield put(
      InitAction.getSuccess({
        projectData: { teams: getTeamsArrayAfterAddTeam(response.data.data) }
      })
    );
    yield put(TeamAction.storeSuccess(action.projectId, response.data.data));
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
  } catch (error) {
    SetMessage(error, true);
    yield put(TeamAction.storeFailure());
  }
}

function updateRequest(id, data) {
  return teamApi.update(id, data);
}

function* update(action) {
  try {
    const response = yield call(updateRequest, action.id, action.data);
    yield put(
        InitAction.getSuccess({
          projectData: { teams: getTeamsArrayAfterEditTeam(response.data.data) }
        })
    );
    yield put(TeamAction.updateSuccess(response.data.data));
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
  } catch (error) {
    SetMessage(error, true);
    yield put(TeamAction.updateFailure());
  }
}

function getLevelsRequest(id) {
  return teamApi.getLevels(id);
}
function* getLevels(action) {
  try {
    const response = yield call(getLevelsRequest, action.id);
    yield put(TeamAction.getLevelsSuccess(response.data));
  } catch (error) {
    const message = SetMessage(error);
    yield put(TeamAction.getLevelsFailure(message));
  }
}

function reorderLevelsRequest(id, data) {
  return teamApi.reorderLevels(id, data);
}
function* reorderLevels(action) {
  try {
    const response = yield call(reorderLevelsRequest, action.id, action.data);
    yield put(TeamAction.reorderLevelsSuccess());
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(goBack());
  } catch (error) {
    SetMessage(error, true);
    yield put(TeamAction.reorderLevelsFailure());
  }
}

function showLevelRequest(id, levelId) {
  return teamApi.showLevel(id, levelId);
}

function* showLevel(action) {
  try {
    const response = yield call(showLevelRequest, action.id, action.levelId);
    yield put(TeamAction.showLevelSuccess(response.data.data));
  } catch (error) {
    const message = SetMessage(error);
    yield put(TeamAction.showLevelFailure(message));
  }
}

function removeLevelRequest(id, levelId) {
  return teamApi.removeLevel(id, levelId);
}
function* removeLevel(action) {
  try {
    const response = yield call(removeLevelRequest, action.id, action.levelId);
    yield put(TeamAction.removeLevelSuccess(action.levelId));
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
  } catch (error) {
    SetMessage(error, true);
    yield put(TeamAction.removeLevelFailure());
  }
}

function storeLevelRequest(id, data) {
  return teamApi.storeLevel(id, data);
}
function* storeLevel(action) {
  try {
    const response = yield call(storeLevelRequest, action.id, action.data);
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(TeamAction.storeLevelSuccess(response.data.data));
  } catch (error) {
    SetMessage(error, true);
    yield put(TeamAction.storeLevelFailure());
  }
}

function updateLevelRequest(id, levelId, data) {
  return teamApi.updateLevel(id, levelId, data);
}
function* updateLevel(action) {
  try {
    const response = yield call(
      updateLevelRequest,
      action.id,
      action.levelId,
      action.data
    );
    yield put(TeamAction.updateLevelSuccess(response.data.data));
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
  } catch (error) {
    SetMessage(error, true);
    yield put(TeamAction.updateLevelFailure());
  }
}

function removeLevelApproverRequest(id, levelId, userId) {
  return teamApi.removeLevelApprover(id, levelId, userId);
}
function* removeLevelApprover(action) {
  try {
    const response = yield call(
      removeLevelApproverRequest,
      action.id,
      action.levelId,
      action.userId
    );
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    const levelsResponse = yield call(getLevelsRequest, action.id);
    yield put(TeamAction.getLevelsSuccess(levelsResponse.data));
    yield put(TeamAction.removeLevelApproverSuccess());
  } catch (error) {
    SetMessage(error, true);
    yield put(TeamAction.removeLevelApproverFailure());
  }
}

function getLevelApproversRequest(id, levelId) {
  return teamApi.getLevelApprovers(id, levelId);
}
function* getLevelApprovers(action) {
  try {
    const response = yield call(
      getLevelApproversRequest,
      action.id,
      action.levelId
    );
    yield put(TeamAction.getLevelApproversSuccess(response.data.data));
  } catch (error) {
    const message = SetMessage(error);
    yield put(TeamAction.getLevelApproversFailure(message));
  }
}

function storeLevelApproverRequest(id, levelId, data) {
  return teamApi.storeLevelApprover(id, levelId, data);
}
function* storeLevelApprover(action) {
  try {
    const response = yield call(
      storeLevelApproverRequest,
      action.id,
      action.levelId,
      action.data
    );
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    const levelsResponse = yield call(getLevelsRequest, action.id);
    yield put(TeamAction.getLevelsSuccess(levelsResponse.data));
    yield put(TeamAction.storeLevelApproverSuccess());
  } catch (error) {
    SetMessage(error, true);
    yield put(TeamAction.storeLevelApproverFailure());
  }
}

function updateWidgetsRequest(id, data) {
  return teamApi.updateWidgets(id, data);
}
function* updateWidgets(action) {
  try {
    const response = yield call(updateWidgetsRequest, action.id, action.data);
    yield put(
        InitAction.getSuccess({
          projectData: { teams: getTeamsArrayAfterEditTeam(response.data.team) }
        })
    );
    yield put(TeamAction.updateWidgetsSuccess());
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    //empty fetched subItems list to avoid having incomplete team_ids list for their items
    switch (parseInt(action.data.widget)) {
      case TEAM_SUB_ITEM.ACCOUNT_TITLE.type:
        yield put(AccountTitleAction.clearList());
        break;
      case TEAM_SUB_ITEM.COST_CENTER.type:
        yield put(CostCenterAction.clearList());
        break;
      case TEAM_SUB_ITEM.HASHTAG.type:
        yield put(HashtagAction.clearList());
        break;
      case TEAM_SUB_ITEM.CONTACT.type:
        yield put(ContactAction.clearList());
        break;
    }
    yield put(SubItemsSharedAction.closeManagementTeamItemsModal());
  } catch (error) {
    SetMessage(error, true);
    yield put(TeamAction.updateWidgetsFailure());
  }
}
